const tables = document.querySelectorAll('.custom-stacked table.tablepress')
tables.forEach(table => {
    const thead = table.querySelector('thead')
    const tbody = table.querySelector('tbody')
    const tfoot = table.querySelector('tfoot')

    let headings = []
    let rows = []
    let footers = []

    if (thead) {
        headings = thead.querySelectorAll('th')
    }

    if (tbody) {
        rows = tbody.querySelectorAll('tr')
    }

    if (tfoot) {
        footers = tfoot.querySelectorAll('th')
    }

    const wrapper_el = document.createElement('div')
    wrapper_el.classList.add('kp-table-stacked')

    headings.forEach((heading, heading_index) => {
        const col_el = document.createElement('div')
        col_el.classList.add('col')
        const heading_el = document.createElement('div')
        heading_el.classList.add('heading')
        heading_el.innerHTML = heading.innerHTML
        col_el.append(heading_el)
        rows.forEach((row) => {
            const cells = row.querySelectorAll('td')
            const cell = cells[heading_index]
            const cell_el = document.createElement('div')
            cell_el.classList.add('cell')
            if (cell.innerHTML.trim() !== '') {
                cell_el.innerHTML = cell.innerHTML
                col_el.append(cell_el)
            }

        })
        wrapper_el.append(col_el)
    })

    footers.forEach(footer => {
        const footer_cell = document.createElement('div')
        footer_cell.classList.add('footer')
        footer_cell.innerHTML = footer.innerHTML
        wrapper_el.append(footer_cell)
    })

    table.parentNode.insertBefore(wrapper_el, table)
})